import React from 'react';
import {MessageBar, MessageBarType} from '@fluentui/react';

class DisplayMessage extends React.Component {

    render() {
        if(!this.props.error) return null;
        return (
            <div>
                <MessageBar
                    messageBarType={MessageBarType.error}>
                    {this.props.error}
                </MessageBar>
            </div>
        );
    }
}

export default DisplayMessage;




// WEBPACK FOOTER //
// ./src/components/CreateSite/DisplayMessage.js